import { getPartnerGuid } from '../../../../lib/access.es6'
import { PARTNERS_WITH_CUSTOMER_RISK_RATING } from '../../../../routes/PartnersEnum'

const HIGH_RISK_RATING = 'High'

// Returned undefined so buildPolicyFilterBody drops the key: only the screening
// engine writes customer_risk_rating onto additional_details, and /complex/filter
// matches by exact value, so sending it for an unscored partner matches nothing.
export const highRiskRatingFilter = () =>
  PARTNERS_WITH_CUSTOMER_RISK_RATING.indexOf(getPartnerGuid()) !== -1
    ? HIGH_RISK_RATING
    : undefined
